import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-erro-validacao',
  templateUrl: './modal-erro-validacao.component.html',
  styleUrls: ['./modal-erro-validacao.component.scss']
})
export class ModalErroValidacaoComponent implements OnDestroy {
  @Input() retornoAssessment: string;
  @Output() confirmValue = new EventEmitter<boolean>();

  titulo: string = 'Atenção';
  mensagem: string = 'Mensagem';
  labelFechar: string = 'Tirar nova foto';
  showFecharBtn: boolean = true;
  showOkBtn: boolean = true;
  isTituloVermelho: boolean = false;

  alive: boolean = true;

  constructor(private bsModalRef: BsModalRef) { }

  ngOnDestroy() {
    this.alive = false;
  }

  showModal(
    options?: {
      titulo?: string,
      mensagem?: string,
      labelFechar?: string,
      labelOk?: string,
      showFecharBtn?: boolean,
      showOkBtn?: boolean,
      isTituloVermelho?: boolean
    }): void {

    if (options) {
      this.titulo = options.titulo || this.titulo;
      this.mensagem = options.mensagem || this.mensagem;
      this.labelFechar = options.labelFechar || this.labelFechar;
      this.showFecharBtn = options.showFecharBtn || this.showFecharBtn;
      this.showOkBtn = options.showOkBtn || this.showOkBtn;
      this.isTituloVermelho = options.isTituloVermelho || this.isTituloVermelho;
    }

  }

  onClickClose() {
    this.confirmValue.emit(true);
    this.bsModalRef.hide();
  }
}
